import usePrivateAxios from '@/common/api/usePrivateAxios'
import { TmaisNfceData, TmaisNfceResponse } from '@/features/tmaisNfces/types/tmaisNfces.type'
import { UseQueryResult, useQuery } from '@tanstack/react-query'

export const useTmaisNfce: (id: string) => UseQueryResult<TmaisNfceData, unknown> = (id) => {
  const privateAxios = usePrivateAxios()

  return useQuery<TmaisNfceResponse, unknown, TmaisNfceData>({
    queryKey: ['tmaisNfce', id],
    queryFn: () => {
      return privateAxios.get(`/tmais/nfces/${id}`)
    },
    select: (data) => data?.data?.data,
  })
}
